export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const ENDPOINTS = {
  LOGIN: "/auth/login",
  SOCIAL: "/auth/social",
  REFRESH: "/auth/refresh",
  LOGOUT: "/auth/logout",
  USERS_ME: "/users/me",
  PROFILE_ME: "/profiles/me",
  PRIVACY_ME: "/privacy/me",
  PAYMENT_CHANNELS: "/payments/channels",
  PAYMENTS_MY: "/payments/my",
  SUBSCRIPTION_PLANS: "/subscriptions/plans",
  SUBSCRIPTION_MY: "/subscriptions/my",
  SUBSCRIPTION_CHECKOUT: "/subscriptions/checkout",
  SUBSCRIPTION_VERIFY: "/subscriptions/verify",
  SUBSCRIPTION_CANCEL: "/subscriptions/cancel",
  ACCOUNT_DELETE_REQUEST: "/users/by-email",
  ACCOUNT_DELETE_REQUEST_CODE: "/users/by-email/request-delete",
  MATCH_REQUEST_MINE: "/admin-match-requests/mine",
  LEADS_BASE: "/admin-match-requests/leads",
  MATCH_REQUEST_CREATE: "/admin-match-requests",
};
